import * as ActionTypes from './../constants/ActionTypes'

const initialState = {
    loading: false,
    user: {},
    users: [],
    evi: {},
    //-------------------
    eva: [],//evidencias
    pageva: 1,
    searcheva: "",

    doc: [],//docentes
    pays: [],
    headerb: [],
    headers: [],
    ne: [],//notasevidencias
    nb: [],//notasbimensuales
    //-------------------
    inbox: [],
    paginbox: 1,
    searchinbox: "",

    sent: [],
    pagsent: 1,
    searchsent: "",
    //-------------------
    tasks: [],
    material: [],
    //-------------------
    fields: {para:[]},
    formErrors: {errors:{}},
    error: false,
    error401: false,
    errorServer: false,
    simpleToast: false,
    toastMessage: "",
    options: [],
    options2: [],
    selectedOption: [],
    selectedOption2: [],
    adjuntos: []
};

export default (state = initialState, action = {}) => {
  let pagination = "pag"+[action.name];
  let more = "loadmore"+[action.name];

  switch(action.type) {
  case ActionTypes.LOADING_CHANGE:
    return {
      ...state,
      loading: !state.loading
    }
  case ActionTypes.DATA:
    return {
      ...state,
      [action.name]: action.items
    };
  case ActionTypes.DATA_CONCAT:
    return {
      ...state,
      [action.name]: state[action.name].concat(action.items)
    };
  case ActionTypes.DATA_WITH_PAGINATION:
    return {
      ...state,
      [action.name]: state[action.name].length === 0 ? action.items : state[action.name].concat(action.items),
      [pagination]: state[pagination] + 1,
      [more]: action.items.length > 0 ? true : false
    };
  case ActionTypes.SET_FIELDS:
    return {
      ...state,
      fields: action.fields
    };
  case ActionTypes.SET_ERROR_FORMS:
    return {
      ...state,
      formErrors: action.errors
    };
  default: return state;
  }
}